import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import 'dayjs/locale/ru'

const area = () => {
  const block = document.getElementById("area");

  if (!block) {
    return;
  }

  dayjs.extend(utc);
  dayjs.extend(timezone);
  dayjs.locale("ru");

  (async function getArea() {
    const loader = document.querySelector(".area__loader");

    try {
      const param = getParam("id");
      const area = await getJson(`https://api.migrant-exam.ru/EducationalProgram/GetExaminationAreaTimeTable?examinationAreaId=${param}`);   

      loader.classList.remove("active");

      if (area.length <= 0) {
        block.innerHTML = `
                <p style="font-size: 20px; color: #E30016; text-align: center; font-weight: 700">К сожалению для данной площадки расписание отсутствует</p>
            `;
      } else {
        dataOutput(area);
      }
    } catch (e) {
      loader.classList.remove("active");
      block.innerHTML = `
                <p style="font-size: 20px; color: #E30016; text-align: center; font-weight: 700">Не удалось подключиться к серверу. Попробуйте зайти позже.</p>
            `;
      console.log(e);
    }
  })();

  const months = {
    1: "Январь",
    2: "Февраль",
    3: "Март",
    4: "Апрель",
    5: "Май",
    6: "Июнь",
    7: "Июль",
    8: "Август",
    9: "Сентябрь",
    10: "Окябрь",
    11: "Ноябрь",
    12: "Декабрь",
  };

  function dataOutput(area) {
    const wrapper = document.createElement("div");
    const content = document.createElement("div");
    const calendar = document.createElement("div");

    wrapper.classList.add("area__wrapper");
    calendar.classList.add("area__calendar");
    content.classList.add("area__content");

    content.innerHTML = `
            ${area.name ? `<p>${area.name}</p>` : ""}
            ${area.address ? `<p>${area.address}</p>` : ""}
            ${area.phone ? `<p><a href="tel:${area.phone}">${area.phone}</a></p>` : ""}
            ${area.email ? `<p><a href="mailto:${area.email}">${area.email}</a></p>` : ""}
            ${area.workingHours ? `<p>${area.workingHours}</p>` : ""} 
        `;

    if (area.exams.length > 0) {
      area.exams.forEach((exam) => {
        calendar.innerHTML += `
                    <div class="area__calendar-block">
                        <h4>${months[exam.month]}</h4>
                        <div class="area__calendar-items">
                            ${getLevel(exam).innerHTML}
                        </div>                    
                    </div>
                `;
      });
    }

    wrapper.append(content);
    wrapper.append(calendar);
    block.append(wrapper);
  }

  /* Получить типы экзаменов */
  function getLevel(exam) {
    const block = document.createElement("div");
    
    exam.availableExams.forEach((element) => {
      if (element.times.length > 0) {
        block.innerHTML += `
                    <div class="area__calendar-item">
                        <h6>${element.level}</h6>
                        <ul>
                            ${getTime(element.times).innerHTML}
                        </ul>
                    </div>
                `;
      }
    });

    return block;
  }

  /* Получить расписание */
  function getTime(times) {
    const block = document.createElement("div");

    times.forEach((element) => {    
      block.innerHTML += `
                <li>${dayjs(convertToUTC(element.examDate)).format("D MMMM YYYY в HH:mm")} - осталось ${
        element.availableQuotaCount
      } ${declination(element.availableQuotaCount, ["место", "места", "мест"])} для записи</li>
            `;
    });

    return block;
  }

  /* Запрос на получение json */
  async function getJson(patch) {
    let response = await fetch(patch),
      result = await response.json();

    return result;
  }

  /* Функция получения определенной utm метки */
  function getParam(param) {
    const urlParams = new URL(window.location.toString()).searchParams;
    return urlParams.get(param) || "";
  }

  // Склонение окончания в тексте
  function declination(number, txt) {
    var cases = [2, 0, 1, 1, 1, 2];
    return txt[
      number % 100 > 4 && number % 100 < 20
        ? 2
        : cases[number % 10 < 5 ? number % 10 : 5]
    ];
  }

  /* Конвертировать дату */    
  const convertToUTC = (date, dateFormat='D MMMM YYYY в HH:mm', tz=dayjs.tz.guess())  => {
    return dayjs.tz(date, dateFormat, tz).utc().toDate()
  }      
};

export default area;
